import React, { useEffect, useState } from 'react';
import editIcon from '../../images/icons/editIcon.svg';
import trash from '../../images/icons/trash.svg';
import ConfirmDelete from '../Modal/ConfirmDelete';
import fetchExpenseItems from './queries/fetchExpenseItems';
import getTotalNoOfPages from '../../utils/getTotalNoOfPages';
import deleteExpenseItem from './queries/deleteExpenseItem';
import showAlert from '../../utils/alert';
import ApiPagination from '../common/ApiPagination';
import HOCSidePanel from './HOCPanel';
import AddNewExpenseNew from './addExpenseNew';
import getCompanyList from '../vendor/queries/getCompanyList';
import editExpenseItem from './queries/editExpenseItem';

const emptyDataObject = {
  expenseLineItem: '',
  purposeID: '',
  accountCodeID: '',
  expenseCategoryID: '',
  documentIdentifier: ''
};

const paginationRowList = [10, 20, 30, 40, 50];

const ExpenseTable = ({
  policies,
  addNewField,
  setaddNewField,
  setEditRowId,
  search,
  categoryList,
  documentMappingList,
  accountCodeList,
  pageNumber,
  setpageNumber,
  rowsCount,
  setrowsCount,
  filterData,
  isFiltering,
  activePanel,
  setActivePanel
}) => {
  const [modal, setModal] = useState(false);
  const [deleteRowId, setDeleteRowId] = useState(null);
  const [columns, setColumns] = useState([]);
  const [totalPages, settotalPages] = useState(0);
  const [editData, setEditData] = useState(null);
  const [modalUpdate, setModalUpdate] = useState(null);
const [pendingForm, setPendingForm] = useState(null);
const [pendingItems, setPendingItems] = useState([]);
const [pendingCategory, setPendingCategory] = useState('');
  const { mutate: editItem, isSuccess: isEditSuccess, isError: isEditError } = editExpenseItem();

  const showDeleteModal = (id) => {
    setDeleteRowId(id);
    setModal(true);
  };
  const { data: companies, mutate: getCompanyByCategory } = getCompanyList();
  const setEditField = (id) => {
    if (addNewField) {
    setaddNewField(false);
    setEditRowId(id);
    } else {
      setEditRowId(id);
    }
  };
useEffect(() => {
  getCompanyByCategory();
}, []);
  useEffect(() => {
    if (policies?.expensePolicies?.canEdit) {
      setColumns(['Category', 'Expense Item', 'Account Code', 'Document Mapping', 'Action']);
    } else {
      setColumns(['Category', 'Expense Item', 'Account Code', 'Document Mapping']);
    }
  }, [policies]);

  useEffect(() => {
    if (search?.length > 2) {
      setpageNumber(1);
    }
  }, [search]);
  const reqObj = { pageNumber, rowsCount, ...filterData };

  const { isLoading, error,
    isFetching, data, isError } = fetchExpenseItems(
      { ...reqObj, expenseLineItem: search?.length > 2 ? search : null }
      );
  const { expenseItemModels: expenseItems, totalRowsCount } = data?.data || {};

  const { mutate: deleteItem, isSuccess: isDeleteSuccess,
    isError: isDeleteError, reset } = deleteExpenseItem();

  const handleDelete = () => {
    deleteItem(deleteRowId);
  };
  useEffect(() => {
    if (isEditSuccess) {
      showAlert(
        `Expense Item ${editData ? 'Updated' : 'Added'} Successfully!`,
        'success'
      );
      setActivePanel(false);
      setEditData(null);
      setModalUpdate(false);
    } else if (isEditError) {
      showAlert('Expense item already exists', 'error');
      setActivePanel(false);
      setModalUpdate(false);
      setEditData(null);
    }
  }, [isEditSuccess, isEditError]);
  useEffect(() => {
    settotalPages(getTotalNoOfPages(totalRowsCount, rowsCount));
  }, [pageNumber, totalRowsCount, rowsCount]);

  if (isError) {
    return <>{error.message}</>;
  }

  const handleRowsCount = (value) => {
    setpageNumber(1);
    setrowsCount(value);
  };

  if (isDeleteSuccess) {
    setModal(false);
    showAlert('Deleted Successfully', 'success');
    reset();
  }

  if (isDeleteError) {
    showAlert('Something went wrong', 'error');
    setModal(false);
    reset();
  }
  const onClose = () => {
    setActivePanel(false);
    setEditData(null);
  };
    const handleSubmit = () => {
       const form = pendingForm;
  const items = pendingItems;
  const selectedCategory = pendingCategory;
      const errors = {};
      const { accountCodeID, expenseCategoryID, expenseLineItem, courseNameId } = form;
      if (!accountCodeID) errors.accountCodeID = 'Account Code is required.';
    if (!expenseCategoryID) errors.expenseCategoryID = 'Category is required.';
    if (!expenseLineItem?.trim()) errors.expenseLineItem = 'Expense Line Item is required.';
    if (selectedCategory === 'Training') {
      if (!courseNameId?.trim()) errors.courseNameId = 'Document is required.';
    }
    const missingCompanyOrAccountCodes = items?.filter(
      (item) => !item.company?.id || !item.accountCode?.id
    );
    if (missingCompanyOrAccountCodes.length > 0) {
      showAlert('Please select both Company and Account Code', 'error');
      return;
    }
      let payload = {
        expenseLineItem,
        expenseCategoryID,
        accountCodeID,
        documentIdentifier: courseNameId,
        companyExpenseAccountCodeList: items.map((item) => ({
          accountCodeID: item.accountCode?.id,
          companyId: item.company?.id
        })),
        ...(editData?.expenseLineItemID && { expenseLineItemID: editData.expenseLineItemID })
      };
      if (editData) {
        const isDocumentChanged = form.courseNameId !== editData.documentIdentifier;
        payload = { ...payload, isDocumentChanged };
        editItem(payload);
      }
    };
    const handleSubmitFromChild = (form, items, selectedCategory) => {
      setPendingForm(form);
      setPendingItems(items);
      const missingCompanyOrAccountCodes = items?.filter(
        (item) => !item.company?.id || !item.accountCode?.id
      );
      if (missingCompanyOrAccountCodes.length > 0) {
        showAlert('Please select both Company and Account Code', 'error');
        return;
      }
      setPendingCategory(selectedCategory);
      setModalUpdate(true);
      setActivePanel(false);
    };
    const cancelFunction = () => {
      setEditData(null);
      setModalUpdate(false);
    };
  return (
    <>
      <HOCSidePanel
      openSidePanel={activePanel}
      onClose={() => onClose()}
      render={() => (
        <AddNewExpenseNew
        mode="add"
        dataObj={emptyDataObject}
        categoryList={categoryList}
        companies={companies}
        editData={editData}
        setEditData={setEditData}
        handleUpdate={handleSubmitFromChild}
        setModalUpdate={setModalUpdate}
        documentMappingList={documentMappingList}
        accountCodeList={accountCodeList}
        setActivePanel={setActivePanel}
        />
      )}
      />
      {modal && (
        <ConfirmDelete
          {...{
            modal,
            deleteRowId,
            setModal,
            deleteItem,
            isDeleteSuccess,
            isDeleteError,
            handleDelete
          }}
          subMessage="This will remove the Expense Item from Vendor to Expense Mapping screen."
          message="Delete"
        />
      )}
          {modalUpdate && (
                <ConfirmDelete
                 modal={modalUpdate}
                 setModal={setModalUpdate}
                 handleDelete={handleSubmit}
                 handleCancel={cancelFunction}
                    subMessage="This update will impact the Vendor-to-Expense Line Item Mapping and/or the Company-to-Account Code Mapping."
                    message="Update"
                />
                )}
      <div className="manning-table muli expense-item ">
        <div className="table-row table-head bg-primary-50 grid-col-4-min">
          {columns.map((item) => (
            <div className="table-cell  capitalize">{item}</div>
          ))}
          <div className="table-cell" />
        </div>
        <div className="table-body custom-scroll">
          {isLoading || isFetching || isFiltering ? (
            <h1>Loading...</h1>
          ) : (
            <>
              {expenseItems && expenseItems.length > 0 ? (
                <>
                  {expenseItems?.map((item) => (
                      <div key={item?.expenseLineItemID} className="table-row grid-col-4-min">
                        <div className="table-cell">
                          <label>{item?.categoryName}</label>
                        </div>
                        <div className="table-cell">
                          <label>{item?.expenseLineItem}</label>
                        </div>
                        <div className="table-cell">
                          <label>{item?.accountCode}</label>
                        </div>
                        <div className="table-cell">
                          <label>
                            {item?.documentIdentifier ? documentMappingList?.find((doc) => doc?.documentIdentifier === item?.documentIdentifier)?.courseName : ''}
                          </label>
                        </div>
                        {policies?.expensePolicies.canEdit && (
                        <div className="table-cell manning-table-action">
                          <button
                            onClick={() => {
                            setEditField(item.expenseLineItemID);
                            setActivePanel(true);
                            setEditData(item);
                            }}
                            type="button"
                            hidden={(item?.categoryName === 'PPE' || item?.categoryName === 'Vessel PPE')}
                          >
                            <img src={editIcon} alt="EditIcon" title="Edit" className="action-icon w-6" />
                          </button>
                          <button onClick={() => showDeleteModal(item.expenseLineItemID)} type="button" hidden={(item?.categoryName === 'PPE' || item?.categoryName === 'Vessel PPE')}>
                            <img src={trash} alt="DeleteIcon" title="Delete" className="action-icon w-6" />
                          </button>
                        </div>
                        )}
                        <div />
                      </div>
                    ))}
                </>
              ) : (
                <h1>No Data Available</h1>
              )}
            </>
          )}
        </div>
      </div>
      {!isLoading && (
        <>
          {totalRowsCount > 5 && (
            <ApiPagination
              {...{
                setpageNumber,
                pageNumber,
                totalPages,
                paginationRowList,
                handleRowsCount,
                rowsCount
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default ExpenseTable;
